/**
 * focoDoAviso — a pessoa está DIGITANDO? (Task 11, 24/10/2026)
 *
 * O aviso da ligação só leva o foco para "Atender" quando isso não rouba nada. Com o cursor num campo
 * (o composer do chat, um formulário), um `Espaço` ou `Enter` do texto que ela escrevia atenderia a ligação,
 * abriria o microfone e, havendo outra ligação, derrubaria a atual (desenho §1.4). Nesse caso o foco fica
 * onde está e o aviso é anunciado ao leitor de tela por uma região própria.
 *
 * Mora aqui, e não dentro do `AvisoDeChamada`, porque quem decide o ANÚNCIO é o `CallProvider` e os dois
 * precisam responder a mesma pergunta do mesmo jeito.
 */

/** Campos em que o teclado escreve: `input`, `textarea`, `select`, `[contenteditable]`, `[role="textbox"]`. */
const CAMPO_EDITAVEL =
  'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"]';

/** O elemento com o foco é um campo editável? Sem foco (o `<body>`) ou em botão/link: `false`. */
export function focoEmCampoEditavel(): boolean {
  if (typeof document === "undefined") return false;
  const ativo = document.activeElement;
  if (!ativo || ativo === document.body) return false;
  return ativo.matches(CAMPO_EDITAVEL);
}
